import { forwardRef } from "react";
function SvgSchoologySvg({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 40 40"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="#333"
        d="M19.413 20.854c-2.456-.587-5.498-1.28-5.498-4.484 0-2.775 2.348-4.537 5.925-4.537 2.936 0 6.032 1.388 6.566 5.018l-2.776.373c-.054-.96-.107-1.708-1.121-2.455-1.014-.8-2.189-.908-2.936-.908-2.029 0-3.043 1.228-3.043 2.242 0 1.442 1.655 1.922 3.683 2.403l1.442.373c1.815.427 5.124 1.228 5.124 4.43 0 2.51-2.188 4.858-6.459 4.858-1.708 0-3.523-.373-4.75-1.227-.481-.374-1.976-1.602-2.296-4.164l2.936-.48c-.053.694-.053 1.975 1.12 2.989.908.8 2.083.907 3.097.907 2.295 0 3.63-.907 3.63-2.562 0-1.761-1.335-2.082-3.203-2.455l-1.441-.32Z"
      />
      <path
        fill="#47B0ED"
        d="M20 7.456C13.114 7.456 7.509 13.114 7.509 20s5.605 12.544 12.544 12.544c6.94 0 12.491-5.658 12.491-12.544S26.94 7.456 20 7.456ZM20 35c-8.274 0-15-6.726-15-15 0-8.274 6.726-15 15-15 8.274 0 15.053 6.726 15.053 15 0 8.274-6.779 15-15.053 15Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgSchoologySvg);
export default ForwardRef;
